import { render, staticRenderFns } from "./AdminUtilities.vue?vue&type=template&id=12a4e07b"
import script from "./AdminUtilities.vue?vue&type=script&lang=js"
export * from "./AdminUtilities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports